import {
  MONTH_PASCAL,
  TARGET_AUDIENCE,
  DAY_PASCAL
} from '../../constants/common';

export interface BasePricingAttributes {
  demographic: string;
  ratecard: RATECARD;
  month: MONTH_PASCAL;
  discount: number;
}

export interface BaseWeeklyPricingAttributes {
  demographic: string;
  ratecard: RATECARD;
  week: number;
  discount: number;
}

export interface PeakLoadingAttributes {
  demographic: TARGET_AUDIENCE;
  peakLoadingPercentage: number;
}

export interface DayLoadingAttributes {
  demographic: TARGET_AUDIENCE;
  day: DAY_PASCAL;
}

export enum RATECARD {
  CPM = 'Ratecard CPM',
  CPT = 'Ratecard CPT'
}

export enum INDEX {
  DEMOGRAPHIC = 0,
  RATECARD = 1,
  STATION = 1,
  HEADER_ROW = 0,
  NOT_FOUND = -1
}

export enum SHEET_RANGE {
  PRICING = 'Pricing!A2:N36',
  PEAK_LOADING = 'Peak Loadings!B6:AJ23',
  STATION_GRID = 'Station Grids!A1:W52',
  DAY_STRAT = 'Day Strat Grids!A5:AT22',
  DURATION_LOADINGS = 'Duration Loadings!A1:B8',
  WEEKLY_PRICING = 'Weekly Pricing!A3:BE37',
  AD_MIRRORING = 'AT Mirror Loading!A2:B19'
}

export enum TVNZ_STATION {
  ONE = 'TVNZ 1 Network',
  TWO = 'TVNZ 2 Network',
  DUKE = 'TVNZ DUKE Network'
}
